<template>
  <div style="width: 200px">
    <a-select
      showSearch
      :value="value"
      :placeholder="$t('accessoriyList.按照车架号和车辆型号模糊搜索')"
      :allowClear="true"
      :defaultActiveFirstOption="false"
      style="width: 100%"
      :showArrow="false"
      :filterOption="false"
      @search="handleSearch"
      @change="handleChange"
      :notFoundContent="null"
      @inputKeydown.enter="inputKeydown"
      @focus="focus"
      @blur="mouseBlur"
    >
      <a-select-option v-for="d in data" :key="d.value">{{
        d.text
      }}</a-select-option>
    </a-select>
  </div>
</template>

<script>
// import querystring from 'querystring';
import { GetUUID } from "../utils/util";
// 去除数据中的重复
function uniqueArray(array, key) {
  var result = [array[0]];
  for (var i = 1; i < array.length; i++) {
    var item = array[i];
    var repeat = false;
    for (var j = 0; j < result.length; j++) {
      if (item[key] === result[j][key]) {
        repeat = true;
        break;
      }
    }
    if (!repeat) {
      result.push(item);
    }
  }
  return result;
}

export default {
  data() {
    return {
      stockpile: {},
      data: [], // 输入记录渲染 { value: '', text: '' }
      dataProcessing: [], // 输入记录渲染之前,进行处理 { value: '', text: '' }
      value: undefined,
    };
  },
  // 父组件 InputPluginValue
  props: {
    columnsResult: { type: Array, default: () => [] },
  },
  mounted() {
    this.stockpile = GetUUID();
  },
  methods: {
    // 文本框内容发生变化,执行
    handleSearch(value) {
      // 获取文本框的值,传递给data中的value
      if (value) {
        this.value = value.trim();
        // 过滤去重复,输入时查找匹配的记录 dataProcessing:数据处理
        this.data = this.dataProcessing.filter(function (item, index) {
          return item.text.indexOf(value) > -1;
        });
      }
    },
    clear() {
      this.value = undefined;
    },
    // 点击保留记录事件
    handleChange(value) {
      if (value) {
        this.value = value;
        // 保留记录进行排序
        let TemArray = [];
        TemArray = JSON.parse(sessionStorage.getItem(this.stockpile));
        TemArray = TemArray.filter(function (item, index) {
          return item.text !== value && item.value !== value;
        });
        sessionStorage.removeItem(this.stockpile);
        TemArray.unshift({ value: this.value, text: this.value });
        sessionStorage.setItem(this.stockpile, JSON.stringify(TemArray));

        console.log(value, 111);
        this.$emit("InputLikeSelect", this.resultSql(this.value)); // 向父组件传值
      } else {
        this.$emit("InputLikeSelect", ""); // 向父组件传值
        this.value = undefined;
      }
    },

    // 键盘回车事件
    inputKeydown() {
      // 判断当前文板框是否为空 undefined
      if (this.value !== undefined) {
        if (this.value !== "") {
          // 判断当前是否有此值,有不添加
          var tmp = [];
          tmp = this.dataProcessing.filter((item, index) => {
            if (item.value === this.value) {
              return item.value;
            }
          });
          // 获取存在的长度,等于0 没有
          if (tmp.length === 0) {
            // dataProcessing数组添加值
            this.dataProcessing.unshift({
              value: this.value,
              text: this.value,
            });
          }

          this.dataProcessing = uniqueArray(this.dataProcessing, "value");

          // 保留50条记录
          if (this.dataProcessing.length > 50) {
            const tem = this.dataProcessing.length;
            for (let i = 0; i < tem - 50; i++) {
              this.dataProcessing.pop();
            }
          }

          // 保存到本地 JSON.stringify()转换成JSON字符串
          sessionStorage.setItem(
            this.stockpile,
            JSON.stringify(this.dataProcessing)
          );

          let sql = "";
          sql = this.resultSql(this.value);
          this.$emit("InputLikeSelect", sql);
        } else {
          this.$emit("InputLikeSelect", this.resultSql(this.value));
        }
      } else {
        this.$emit("InputLikeSelect", this.resultSql(this.value));
      }
    },

    // 获取焦点事件
    focus() {
      // 获取焦点时,清空data数据中的值
      this.dataProcessing = [];
      this.data = [];

      if (sessionStorage.getItem(this.stockpile) === null) {
        return;
      } else {
        // JSON.parse() 将数据转化成对象
        this.data = JSON.parse(sessionStorage.getItem(this.stockpile));
      }
      this.dataProcessing = this.data;
    },
    //  鼠标移除事件
    mouseBlur() {
      this.data.forEach((item) => {
        if (!item.value === this.value) {
          this.value = undefined;
        }
      });
    },

    // 封装sql
    resultSql(value) {
      if (value === undefined || value === "") {
        return "";
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
